import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/sports';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-trophy-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                九游体育
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              专业的体育赛事平台，覆盖足球、篮球、网球等热门赛事，提供实时赛况、数据分析、赛事直播及体育资讯服务。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              赛事分类
            </h4>
            <ul className="space-y-3">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  免责声明
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-sm text-background-500 mt-0.5"></i>
                <span className="text-sm text-background-400">{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-sm text-background-500 mt-0.5"></i>
                <span className="text-sm text-background-400">{siteInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-sm text-background-500 mt-0.5"></i>
                <span className="text-sm text-background-400">{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow noopener" className="hover:text-background-400 transition-colors">京ICP备2024XXXXXXXX号</a>
            </p>
            <p className="text-sm text-background-500">
              让每一场比赛都精彩无限
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}